// Shared shimmer skeleton components for all optimization pages.
// CSS classes are defined in styles.css (.shimmer-bg, .shimmer-icon, etc.)

const KPI_TYPES = ['t1', 't2', 't3', 't4'];

export const KpiSkeleton = ({ count = 4, cols = null }) => (
  <div className={`kpi-row${cols ? ` cols-${cols}` : ''}`}>
    {Array.from({ length: count }, (_, i) => KPI_TYPES[i % KPI_TYPES.length]).map((type, i) => (
      <div key={i} className={`kpi ${type}`}>
        <div className="ico kpi-ico-skeleton">
          <div className="shimmer-bg shimmer-icon" />
        </div>
        <div className="shimmer-flex">
          <div className="shimmer-bg shimmer-title" />
          <div className="shimmer-bg shimmer-val" />
          <div className="shimmer-bg shimmer-sub" />
        </div>
      </div>
    ))}
  </div>
);

export const InsightSkeleton = () => (
  <div className="insight-skeleton-wrap">
    <div className="shimmer-bg shimmer-title" />
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="insight-item insight-item-skeleton-wrap">
        <div className="insight-item-skeleton-top">
          <div className="shimmer-bg shimmer-insight-title" />
          <div className="shimmer-bg shimmer-insight-amt" />
        </div>
        <div className="shimmer-bg shimmer-insight-desc" />
        <div className="shimmer-bg shimmer-insight-btn" />
      </div>
    ))}
  </div>
);

export const BadgeSkeleton = () => (
  <span className="badge shimmer-bg shimmer-badge" />
);

export const SvcGridSkeleton = ({ count = 5 }) => (
  <div className="svc-grid" style={{ gridTemplateColumns: `repeat(${count}, 1fr)`, marginBottom: 14 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} style={{ background: '#fff', border: '1px solid #e9ecf2', borderRadius: 11, overflow: 'hidden', padding: 0 }}>
        <div className="shimmer-bg" style={{ height: 36, borderRadius: 0, marginBottom: 0 }} />
        <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="shimmer-bg" style={{ width: '55%', height: 10 }} />
            <div className="shimmer-bg" style={{ width: 44, height: 20, borderRadius: 10 }} />
          </div>
          <div className="shimmer-bg" style={{ width: '100%', height: 44, borderRadius: 6 }} />
        </div>
      </div>
    ))}
  </div>
);

export const ChartGridSkeleton = ({ cols = 3 }) => (
  <div className="dash-grid-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)`, marginBottom: 14 }}>
    {Array.from({ length: cols }).map((_, i) => (
      <div key={i} style={{ background: '#fff', border: '1px solid #e9ecf2', borderRadius: 11, padding: '16px 18px' }}>
        <div className="shimmer-bg" style={{ width: '60%', height: 13, marginBottom: 6 }} />
        <div className="shimmer-bg" style={{ width: '40%', height: 10, marginBottom: 18 }} />
        {Array.from({ length: 5 }).map((_, j) => (
          <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <div className="shimmer-bg" style={{ width: 68, height: 10, flexShrink: 0 }} />
            <div className="shimmer-bg" style={{ width: `${30 + (j * 12) % 50}%`, height: 16, borderRadius: 4 }} />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export const TableSkeleton = ({ rows = 5, cols = 5, title }) => (
  <div style={{ background: '#fff', border: '1px solid #e9ecf2', borderRadius: 11, marginBottom: 14, overflow: 'hidden' }}>
    <div style={{ padding: '14px 18px', borderBottom: '1px solid #e9ecf2', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {title
        ? <div className="shimmer-bg" style={{ width: 220, height: 14 }} />
        : <div className="shimmer-bg" style={{ width: 160, height: 14 }} />}
      <div className="shimmer-bg" style={{ width: 72, height: 28, borderRadius: 7 }} />
    </div>
    <div style={{ overflowX: 'auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, background: '#4a5a72', padding: '12px 18px', gap: 8 }}>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="shimmer-bg" style={{ height: 11, opacity: 0.4 }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, padding: '13px 18px', gap: 8, borderBottom: '1px solid #f1f3f8' }}>
          {Array.from({ length: cols }).map((_, c) => (
            <div key={c} className="shimmer-bg" style={{ height: 11, width: `${55 + ((r + c) * 17) % 40}%` }} />
          ))}
        </div>
      ))}
    </div>
    <div style={{ padding: '12px 18px', borderTop: '1px solid #f1f3f8' }}>
      <div className="shimmer-bg" style={{ width: 160, height: 10, marginLeft: 'auto' }} />
    </div>
  </div>
);

export const RecsPanelSkeleton = () => (
  <div style={{ background: '#fff', border: '1px solid #e9ecf2', borderRadius: 11, overflow: 'hidden' }}>
    <div style={{ padding: '14px 18px', borderBottom: '1px solid #e9ecf2' }}>
      <div className="shimmer-bg" style={{ width: 130, height: 14 }} />
    </div>
    <div style={{ padding: '14px 18px', display: 'flex', flexDirection: 'column', gap: 14 }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="shimmer-bg" style={{ width: '55%', height: 11 }} />
            <div className="shimmer-bg" style={{ width: 60, height: 11 }} />
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <div className="shimmer-bg" style={{ width: 60, height: 20, borderRadius: 10 }} />
            <div className="shimmer-bg" style={{ width: 70, height: 20, borderRadius: 10 }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);
